import * as tslib_1 from "tslib";
import * as dialogStateActions from './dialogState/Actions';
import * as googleGeoCoderActions from './googleGeoCoder/Actions';
import * as submitStateActions from './submitState/Actions';
import * as baggageInfoActions from './baggageinfo/Actions';
import * as bookapiInsurancesActions from './bookapiInsurances/Actions';
import * as bookapiPaymentsActions from './bookapiPayments/Actions';
import * as bookapiFlexRateActions from './bookapiFlexRate/Actions';
import * as bookapiRoomCateringUpsellingActions from './bookapiRoomCateringUpselling/Actions';
import * as bookapiTrainRatesActions from './bookapiTrainRates/Actions';
import * as bookapiTransferOffersActions from './bookapiTransferOffers/Actions';
export var bookingActions = tslib_1.__assign({}, dialogStateActions, googleGeoCoderActions, submitStateActions, baggageInfoActions, bookapiInsurancesActions, bookapiPaymentsActions, bookapiFlexRateActions, bookapiRoomCateringUpsellingActions, bookapiTrainRatesActions, bookapiTransferOffersActions);
